import { render } from "./NavBox.vue?vue&type=template&id=670775d6&scoped=true"
import script from "./NavBox.vue?vue&type=script&lang=js"
export * from "./NavBox.vue?vue&type=script&lang=js"

import "./NavBox.vue?vue&type=style&index=0&id=670775d6&scoped=true&lang=css"

import exportComponent from "D:\\workfile\\flycat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670775d6"]])

export default __exports__